module.exports = __webpack_public_path__ + "static/media/1.320d6406.svg";